module.exports = __webpack_public_path__ + "img/career_select_03.bcd6f84b.png";